import { Table } from '@backstage/core-components';

import { useAccountEntities } from '../hooks/useAccountEntities';
import { EntityRefLink } from '@backstage/plugin-catalog-react';

interface KeyTableProps {
  accounts?: string[];
  actions?: any;
}

export function KMSKeyTableCard({
  accounts = [],
  actions = [],
}: KeyTableProps) {
  const { loading, entities } = useAccountEntities(accounts);

  const columns = [
    {
      title: 'Account ID',
      field: 'metadata.annotations',
      width: '30%',
      render: (rowData: any) => {
        return rowData.metadata.annotations['amazonaws.com/account-id'];
      },
    },
    {
      title: 'Name',
      field: 'metadata.name',
      width: '80%',
      render: (rowData: any) => {
        return (
          <EntityRefLink
            entityRef={{
              kind: 'Resource',
              namespace: 'default',
              name: rowData.metadata.name,
            }}
          />
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      data={entities}
      isLoading={loading}
      options={{
        showTitle: false,
        loadingType: 'linear',
        header: false,
        search: false,
        padding: 'dense',
        toolbar: false,
        paging: entities.length > 5,
        pageSizeOptions: [5],
      }}
      actions={actions}
    />
  );
}
